import React from "react";
import { Link } from "react-router-dom";
import { FiArrowUpRight } from "react-icons/fi";
import {LogoRound} from "shared/Logo/Logo";
import SalonsAndSpas from "components/FooterCitySelector/SalonsAndSpas";
import StartUpIndia from "../../images/startup-india.webp";

const Footer: React.FC = () => {
  return (
    <footer className="">
      <div style={{ minHeight: '500px', contain: 'content' }}>
        <SalonsAndSpas />
      </div>
      <div className="mt-8 py-8 bg-gray-100 container mx-auto text-sm text-neutral-700" style={{ minHeight: '200px' }}>
        
        {/* Logo and Startup India in a row (mobile) and column (desktop) */}
        <div className="flex flex-row justify-start items-center mb-6 md:hidden">
          <LogoRound className="flex justify-start" title="Feelaxo - Book Salons, Spas, and Wellness Centers Online" alt="Feelaxo - Book Salons, Spas, and Wellness Centers Online" />
          <img 
            src={StartUpIndia} 
            alt="Startup India" 
            className="h-16" 
            title="Feelaxo is recognized by Startup India"
          />
        </div>
        
        <div className="grid grid-cols-2 md:grid-cols-5 gap-6">

          {/* Logo & App Download - hidden on mobile, visible on desktop */}
          <div className="hidden md:flex flex-col items-center gap-6 justify-start mb-6" style={{ minHeight: '60px' }}>
            <LogoRound title="Feelaxo - Book Salons, Spas, and Wellness Centers Online" alt="Feelaxo - Book Salons, Spas, and Wellness Centers Online" />
            <img 
              src={StartUpIndia} 
              alt="Startup India" 
              className="h-16" 
              title="Feelaxo is recognized by Startup India"
            />
          </div>

          {/* About Section */}
          <div style={{ minHeight: '150px' }}>
            <h2 className="font-semibold">About Feelaxo</h2>
            <ul className="mt-4 space-y-2">
              <li><Link to="https://business.feelaxo.com/about-feelaxo/">About Us</Link></li>
              <li><Link to="/contact">Support</Link></li>
              <li><Link to="https://business.feelaxo.com/business-blog-for-beauty-and-wellness/">Blog</Link></li>
              <li><a href="/sitemap">sitemap</a></li>
            </ul>
          </div>

          {/* Business Section */}
          <div style={{ minHeight: '150px' }}>
            <h2 className="font-semibold">For Business</h2>
            <ul className="mt-4 space-y-2">
              <li><a href="https://pos.feelaxo.com/">For Partners</a></li>
              <li><Link to="/contact-for-demo">Pricing</Link></li>
              <li><Link to="/contact">Support</Link></li>
            </ul>
          </div>

          {/* Legal & Socials */}
          <div style={{ minHeight: '150px' }}>
            <h2 className="font-semibold">Legal</h2>
            <ul className="mt-4 space-y-2">
              <li><Link to="/privacyPolicy">Privacy Policy</Link></li>
              <li><Link to="/termsCondition">Terms of Service</Link></li>
              <li><Link to="/termsCondition">Terms of Use</Link></li>
            </ul>
          </div>
          
          <div style={{ minHeight: '150px' }}>
            <h2 className="font-semibold">Find us on social</h2>
            <ul className="mt-4 space-y-2">
              <li><a href="https://facebook.com/feelaxo" target="_blank" rel="noopener noreferrer" className="flex items-center space-x-2"><FiArrowUpRight className="h-4 w-4" />Facebook </a></li>
              {/* <li><a href="https://twitter.com/feelaxo" target="_blank" rel="noopener noreferrer" className="flex items-center space-x-2"><FiArrowUpRight className="h-4 w-4" />Twitter </a></li> */}
              <li><a href="https://www.linkedin.com/company/feelaxo/" target="_blank" rel="noopener noreferrer" className="flex items-center space-x-2"><FiArrowUpRight className="h-4 w-4" />LinkedIn </a></li>
              <li><a href="https://instagram.com/feelaxo" target="_blank" rel="noopener noreferrer" className="flex items-center space-x-2"><FiArrowUpRight className="h-4 w-4" />Instagram</a></li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
